import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { TimeSpan } from '@/utility/time-span';

const TickInterval = TimeSpan.minutes.one;

export function useBoutiqueCurrentTime(): Dayjs {
	const [now, setNow] = useState<Dayjs>(() => dayjs());

	useEffect(() => {
		let intervalId: ReturnType<typeof setInterval> | undefined;
		const tick = () => setNow(dayjs());
		const delayToNextMinute = TickInterval - (Date.now() % TickInterval);

		const timeoutId = setTimeout(() => {
			tick();
			intervalId = setInterval(tick, TickInterval);
		}, delayToNextMinute);

		return () => {
			clearTimeout(timeoutId);
			if (intervalId) clearInterval(intervalId);
		};
	}, []);

	return now;
}
